<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="发货"
      :visible.sync="send_box_show"
    >
      <div>
        <div class="pub_box">
          <div class="pub_title">快递公司</div>
          <el-select
            v-model="expressCompany"
            style="width: 320px"
            placeholder="请选择快递公司"
          >
            <el-option
              v-for="item in express_list"
              :label="item.name"
              :key="item.id"
              :value="item.name"
            ></el-option>
            <!-- <el-option label="顺丰" value="顺丰"></el-option> -->
          </el-select>
        </div>
        <div class="pub_box">
          <div class="pub_title" style="align-self: flex-start">快递单号</div>
          <div>
            <div
              class="pub_i_inp"
              v-for="(item, index) in input_list"
              :key="index"
            >
              <el-input v-model="item.value" style="width: 320px"></el-input>
              <i
                class="el-icon-circle-plus-outline"
                style="margin-left: 10px; color: #409eff; cursor: pointer"
                v-if="item.type == 'add'"
                @click="add_input"
              ></i>
              <i
                class="el-icon-remove-outline"
                style="margin-left: 10px; color: #409eff; cursor: pointer"
                v-if="item.type == 'reduce'"
                @click="reduce_input(index)"
              ></i>
            </div>
          </div>
        </div>
        <div class="pub_box">
          <div class="pub_title">发货状态</div>
          <div>
            <el-radio v-model="status" label="WAIT_CONFIRM_SIGNED"
              >全部发货</el-radio
            >
            <el-radio v-model="status" label="PART_SEND_GOODS"
              >部分发货</el-radio
            >
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="send_box_show = false">取 消</el-button>
        <el-button type="primary" @click="sub_send">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
let _this;
import { send_order, get_express, send_cusorder } from "@/request/api/order";
export default {
  props: ["dialogShow", "orderId", "orderType"],
  watch: {
    dialogShow(newdata) {
      _this.send_box_show = newdata;
    },
    send_box_show(newdata) {
      _this.$emit("changeshow", newdata);
    },
  },
  data() {
    return {
      ewaybillCode: [],
      send_box_show: false,
      express_list: [],
      input_list: [
        {
          value: "",
          type: "add",
        },
      ],
      expressCompany: "",
      status: "",
    };
  },
  created() {
    _this = this;
    get_express().then((res) => {
      console.log(res);
      _this.express_list = res.data;
    });
  },
  methods: {
    sub_send() {
      _this.input_list.forEach((item) => {
        if (item.value) {
          _this.ewaybillCode.push(item.value);
        }
      });
      if (!_this.ewaybillCode.length) {
        _this.$api.e_msg("快递单号为空");
        return;
      }
      if (!_this.status) {
        _this.$api.e_msg("发货状态未选择");
        return;
      }
      if (!_this.expressCompany) {
        _this.$api.e_msg("请选择快递公司");
        return;
      }

      if (_this.orderType == "general") {
          console.log('普通单')
        //   普通单发货
        send_order({
          id: _this.orderId,
          expressCompany: _this.expressCompany,
          status: _this.status,
          ewaybillCode: _this.ewaybillCode,
        }).then((res) => {
          if (res.code == 0) {
            // _this.$parent.$parent.$refs.status_bar.get_order(
            //   _this.$parent.$parent.page_order_data
            // );
            _this.$router.go(0)
            _this.send_box_show = false;
            _this.$api.s_msg(res.msg);
          } else {
            _this.$api.e_msg(res.msg);
          }
        });
      } else if (_this.orderType == "custom") {
          console.log('定制单')
        // 定制单发货
        send_cusorder({
          id: _this.orderId,
          expressName: _this.expressCompany,
          status: _this.status,
          expressCodes: _this.ewaybillCode,
        }).then((res) => {
          if (res.code == 0) {
            // _this.$parent.$parent.$refs.status_bar.get_order(
            //   _this.$parent.$parent.page_order_data
            // );
            _this.$router.go(0)
            _this.send_box_show = false;
            _this.$api.s_msg(res.msg);
          } else {
            _this.$api.e_msg(res.msg);
          }
        })
      }
    },
    add_input() {
      let obj = { value: "", type: "reduce" };
      this.input_list.push(obj);
    },
    reduce_input(index) {
      this.input_list.splice(index, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.pub_box /deep/ .el-input__inner {
  line-height: 35px;
  height: 35px;
}
.pub_box {
  display: flex;
  align-items: center;
  line-height: 35px;
  margin-bottom: 10px;
  .pub_i_inp {
    display: flex;
    align-items: center;
    font-size: 28px;
    margin-bottom: 10px;
  }
  .pub_title {
    width: 100px;
  }
}
</style>